export default {
  getErrorResponse(error) {
    if (error?.response?.data) {
      const statusCode = error.request.status;
      const d = error?.response?.data;
      const userAlreadyExists =
        d.errorDescription !== null &&
        d.errorDescription === 'Este visualizador já existe'
          ? 409
          : statusCode;
      const message =
        'Desculpe não foi possível concluir a ação no momento. Voce será redirecionado para página principal. Por favor, tente novamente.';
      return {
        data: {},
        code: d.errorCode || 500,
        message:
          statusCode >= 400 && statusCode < 500 ? message : d.errorDescription,
        status: userAlreadyExists
      };
    }
    if (error.request) {
      return {
        data: {},
        code: 8000,
        message: 'Não foi possível estabelecer uma conexão com o servidor.'
      };
    }
    return {
      data: {},
      code: 9000,
      message: error || 'Não foi possível criar a requisição para o servidor.'
    };
  }
};
